var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        placement: "left",
        width: "690",
        trigger: "click",
        "popper-class": "more_popover",
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", [
        _c("div", { staticClass: "more_popover_top" }, [
          _c(
            "div",
            { staticClass: "mb-16" },
            [
              _c(
                "el-autocomplete",
                {
                  attrs: {
                    "popper-class": "my-autocomplete",
                    "value-key": "label",
                    "fetch-suggestions": _vm.querySearch,
                    placeholder: "请输入内容",
                    size: "mini",
                  },
                  on: { select: _vm.searchHandle },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("textOverflow", [
                            _c("span", {
                              staticClass: "name",
                              domProps: {
                                innerHTML: _vm._s(_vm.setSelectText(item)),
                              },
                            }),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.state,
                    callback: function ($$v) {
                      _vm.state = $$v
                    },
                    expression: "state",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "search-btn",
                      attrs: {
                        slot: "append",
                        size: "mini",
                        icon: "el-icon-search",
                      },
                      slot: "append",
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "more_popover_content",
              style: { height: _vm.isArea ? "414px" : "370px" },
            },
            [
              _c(
                "div",
                { ref: "menus", staticClass: "hierarchy" },
                [
                  _vm._l(_vm.menus, function (panel, i) {
                    return [
                      _c("SubPanel", {
                        key: i,
                        staticClass: "sub-pane",
                        style:
                          i == _vm.menus.length - 1
                            ? "flex: 1 1 0%;"
                            : "flex: 0 1 0%;",
                        attrs: {
                          data: panel,
                          activePath: _vm.activePath,
                          level: i,
                        },
                        on: {
                          selected: _vm.clickSelect,
                          selectedAll: _vm.clearSub,
                        },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
          _c("div", { staticClass: "div-selected" }, [
            _c("p", [
              _vm._v("已选（"),
              _c("span", [_vm._v(_vm._s(_vm.selectedList.length))]),
              _vm._v("/" + _vm._s(_vm.maxSelected) + "）"),
              _c(
                "span",
                {
                  staticClass: "ml-10",
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.clearAll },
                },
                [_vm._v("清空")]
              ),
            ]),
            _c(
              "div",
              _vm._l(_vm.selectedList, function (item, i) {
                return _c(
                  "span",
                  {
                    key: i,
                    on: {
                      click: function ($event) {
                        return _vm.deleteTag(i)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.parent
                            ? item.parent.label + "-" + item.label
                            : item.label
                        ) +
                        " "
                    ),
                    _c("i", { staticClass: "el-icon-close" }),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "more_popover_bottom" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", type: "text" },
                on: { click: _vm.cancelHandle },
              },
              [_vm._v("取消")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.submitHandle },
              },
              [_vm._v("确定")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          class: ["showMore", { "is-opened": _vm.visible }],
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _vm._v(_vm._s(_vm.popoverText) + " "),
          _c("i", { staticClass: "el-submenu__icon-arrow el-icon-arrow-down" }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }